import { lazy, Suspense } from "react";

import { MULTI_ANALYSIS_MEASURE_TYPE, type IMultiAnalysisDataMark } from "../../../multi-analysis/types";
import type { ISpeedScreenFormContentProps, ISpeedScreenFormStrategy, ISpeedScreenFormTimePanelProps } from "../types";
import { isCascadeDataMark } from "./model";
import { CascadeTimePanel } from "./time-panel";
import { CascadeDataMarkTooltip } from "./tooltip";

const CascadeScreenForm = lazy(() => import("./view").then(module => ({ default: module.CascadeScreenForm })));

export class CascadeScreenFormStrategy implements ISpeedScreenFormStrategy {
  readonly id = "cascade" as const;
  readonly titleId = "pages.speed.screenForms.cascade";
  readonly measureType = MULTI_ANALYSIS_MEASURE_TYPE.SPECTRUM;

  render(props: ISpeedScreenFormContentProps) {
    return (
      <Suspense fallback={null}>
        <CascadeScreenForm {...props} />
      </Suspense>
    );
  }

  renderTimePanel(props: ISpeedScreenFormTimePanelProps) {
    return <CascadeTimePanel {...props} />;
  }

  renderDataMarkTooltip(mark: IMultiAnalysisDataMark) {
    return isCascadeDataMark(mark) ? <CascadeDataMarkTooltip mark={mark} /> : null;
  }
}
